//基础数据

export default [
    {
        path: "basicdata/manageware",
        name: "basicdataManageware",
        component: () => import(/* webpackChunkName: "basicdata" */ "@/views/basicdata/manageware/index"),
    },
    {
        path: "basicdata/manageware/update/:type",
        name: "basicdataManagewareUpdate",
        component: () => import(/* webpackChunkName: "basicdata" */ "@/views/basicdata/manageware/update"),
    },
    // {
    //     path: "basicdata/warehouse",
    //     name: "basicdataWarehouse",
    //     component: () => import(/* webpackChunkName: "basicdata" */ "@/views/basicdata/warehouse/index"),
    // },
    {
        path: "basicdata/warehouselist",
        name: "basicdataWarehouseList",
        component: () => import(/* webpackChunkName: "basicdata" */ "@/views/basicdata/warehouselist/index")
    },
    {
        path: "basicdata/warehouselist/update/:type",
        name: "basicdataWarehouseListUpdate",
        component: () => import(/* webpackChunkName: "basicdata" */ "@/views/basicdata/warehouselist/update")
    },
    {
        path: "basicdata/carrier",
        name: "basicdataCarrier",
        component: () => import(/* webpackChunkName: "basicdata" */ "@/views/basicdata/carrier/index"),
    },
    {
        path: "basicdata/carrier/update/:type",
        name: "basicdataCarrierUpdate",
        component: () => import(/* webpackChunkName: "basicdata" */ "@/views/basicdata/carrier/update"),
    },
    {
        path: "basicdata/carrierservice",
        name: "basicdataCarrierservice",
        component: () => import(/* webpackChunkName: "basicdata" */ "@/views/basicdata/carrierservice/index"),
    },
    {
        path: "basicdata/carrierservice/update/:type",
        name: "basicdataCarrierserviceUpdate",
        component: () => import(/* webpackChunkName: "basicdata" */ "@/views/basicdata/carrierservice/update"),
    },
    {
        path: "basicdata/organization",
        name: "basicdataOrganization",
        component: () => import(/* webpackChunkName: "basicdata" */ "@/views/basicdata/organization/index"),
    },
    {
        path: "basicdata/organization/update/:type",
        name: "basicdataOrganizationUpdate",
        component: () => import(/* webpackChunkName: "basicdata" */ "@/views/basicdata/organization/update"),
    },
    {
        path: "basicdata/organization/update/:type",
        name: "basicdataOrganizationUpdate",
        component: () => import(/* webpackChunkName: "basicdata" */ "@/views/basicdata/organization/update"),
    },

    //客户合同管理
    {
        path: "basicdata/customercontract/list",
        name: "basicdataCustomerontract",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/basicdata/customercontract/index"),
    },
    {
        path: "basicdata/customercontract/update/:type",
        name: "basicdataCustomercontractUpdate",
        component: () => import(/* webpackChunkName: "bespeak" */ "@/views/basicdata/customercontract/update"),
    },

    // 仓库承运商账户配置
    {
        path: "basicdata/carrieraccount",
        name: "basicdataCarrierAccount",
        component: () => import(/* webpackChunkName: "basicdata" */ "@/views/basicdata/carrieraccount/index"),
    },
    {
        path: "basicdata/carrieraccount/update/:type",
        name: "basicdataCarrierAccountUpdate",
        component: () => import(/* webpackChunkName: "basicdata" */ "@/views/basicdata/carrieraccount/update"),
    },
    // TMS货代港口管理
    {
        path: "basicdata/forwarderport",
        name: "basicdataForwarderport",
        component: () => import(/* webpackChunkName: "basicdata" */ "@/views/basicdata/forwarderport/index"),
    },
    // TMS系统港口管理
    {
        path: "basicdata/systemport",
        name: "basicdataSystemport",
        component: () => import(/* webpackChunkName: "basicdata" */ "@/views/basicdata/systemport/index"),
    },
    // 门店管理
    {
        path: "basicdata/gateshop",
        name: "basicdataGateshop",
        component: () => import(/* webpackChunkName: "basicdata" */ "@/views/basicdata/gateshop/index"),
    },
     // 区域管理
     {
        path: "basicdata/area",
        name: "basicdataArea",
        component: () => import(/* webpackChunkName: "basicdata" */ "@/views/basicdata/area/index"),
    },
    // 仓库线下订单
    {
        path: "basicdata/warehouseoffline",
        name: "basicdataWarehouseOffline",
        component: () => import(/* webpackChunkName: "basicdata" */ "@/views/basicdata/warehouseoffline/index")
    }
]
